import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';
import axios from 'axios';

export const FETCH_PARTNER_OFFER_REQUEST = 'FETCH_PARTNER_OFFER_REQUEST';
export const FETCH_PARTNER_OFFER_SUCCESS = 'FETCH_PARTNER_OFFER_SUCCESS';
export const FETCH_PARTNER_OFFER_ERROR = 'FETCH_PARTNER_OFFER_ERROR';


export const GET_PARTNER_OFFER_DETAIL_REQUEST =
    'GET_PARTNER_OFFER_DETAIL_REQUEST';
export const GET_PARTNER_OFFER_DETAIL_SUCCESS =
    'GET_PARTNER_OFFER_DETAIL_SUCCESS';
export const GET_PARTNER_OFFER_DETAIL_ERROR = 'GET_PARTNER_OFFER_DETAIL_ERROR';

export const CREATE_PARTNER_OFFER_REQUEST = 'CREATE_PARTNER_OFFER_REQUEST';
export const CREATE_PARTNER_OFFER_SUCCESS = 'CREATE_PARTNER_OFFER_SUCCESS';
export const CREATE_PARTNER_OFFER_ERROR = 'CREATE_PARTNER_OFFER_ERROR';

export const UPDATE_PARTNER_OFFER_REQUEST = 'UPDATE_PARTNER_OFFER_REQUEST';
export const UPDATE_PARTNER_OFFER_SUCCESS = 'UPDATE_PARTNER_OFFER_SUCCESS';
export const UPDATE_PARTNER_OFFER_ERROR = 'UPDATE_PARTNER_OFFER_ERROR';

export const DELETE_PARTNER_OFFER_REQUEST = 'DELETE_PARTNER_OFFER_REQUEST';
export const DELETE_PARTNER_OFFER_SUCCESS = 'DELETE_PARTNER_OFFER_SUCCESS';
export const DELETE_PARTNER_OFFER_ERROR = 'DELETE_PARTNER_OFFER_ERROR';

export const fetchPartnerOffer = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                FETCH_PARTNER_OFFER_REQUEST,
                FETCH_PARTNER_OFFER_SUCCESS,
                FETCH_PARTNER_OFFER_ERROR,
            ],
            callAPI: () => ApiClient.post('network/PartnerOffer/Search', data),
            payload: { data },
        }),
    );
};

export const getPartnerOfferDetail = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                GET_PARTNER_OFFER_DETAIL_REQUEST,
                GET_PARTNER_OFFER_DETAIL_SUCCESS,
                GET_PARTNER_OFFER_DETAIL_ERROR,
            ],
            callAPI: () => ApiClient.get(`network/PartnerOffer/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const createPartnerOffer = (data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [
                CREATE_PARTNER_OFFER_REQUEST,
                CREATE_PARTNER_OFFER_SUCCESS,
                CREATE_PARTNER_OFFER_ERROR,
            ],
            callAPI: () => ApiClient.post('network/PartnerOffer', data),
            payload: { data, formId },
        }),
    );
};


export const updatePartnerOffer = (id, data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [
                UPDATE_PARTNER_OFFER_REQUEST,
                UPDATE_PARTNER_OFFER_SUCCESS,
                UPDATE_PARTNER_OFFER_ERROR,
            ],
            callAPI: () => ApiClient.put(`network/PartnerOffer/${id}`, data),
            payload: { data: { ...data, id }, formId },
        }),
    );
};

export const deletePartnerOffer = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                DELETE_PARTNER_OFFER_REQUEST,
                DELETE_PARTNER_OFFER_SUCCESS,
                DELETE_PARTNER_OFFER_ERROR,
            ],
            callAPI: () => ApiClient.delete(`network/PartnerOffer/${id}`),
            payload: { data: { id } },
        }),
    );
};

const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
};

export default function reducer(state = initialState, action) {
    const { payload, response, error, successMessage, errorMessage } = action;
    switch (action.type) {
        case FETCH_PARTNER_OFFER_REQUEST:
        case GET_PARTNER_OFFER_DETAIL_REQUEST:
        case CREATE_PARTNER_OFFER_REQUEST:
        case UPDATE_PARTNER_OFFER_REQUEST:
        case DELETE_PARTNER_OFFER_REQUEST:
            return {
                ...state,
                payload,
                response: {},
                error: {},
                successMessage: '',
                errorMessage: '',
            };

            return {
                ...state,
                data: { ...state.data, options: response.data.data },
                response,
                successMessage,
            };

        case FETCH_PARTNER_OFFER_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    items: response.data.data.items,
                    pages: response.data.data.pageCount,
                },
                response,
                successMessage,
            };

        case GET_PARTNER_OFFER_DETAIL_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    item: response.data.data,
                },
                response,
                successMessage,
            };

        case CREATE_PARTNER_OFFER_SUCCESS:
        case UPDATE_PARTNER_OFFER_SUCCESS:
        case DELETE_PARTNER_OFFER_SUCCESS:
            return {
                ...state,
                response,
                successMessage,
            };

        case FETCH_PARTNER_OFFER_ERROR:
        case GET_PARTNER_OFFER_DETAIL_ERROR:
        case CREATE_PARTNER_OFFER_ERROR:
        case UPDATE_PARTNER_OFFER_ERROR:
        case DELETE_PARTNER_OFFER_ERROR:
            return {
                ...state,
                payload,
                error,
                errorMessage,
            };
        default:
            return state;
    }
}
